const initialState = {
  data: [],
  total: 0,
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ANNOUNCEMENTS':
      return {
        ...state,
        data: action.payload.announcements,
        total: action.payload.announcements.length,
      }
    default:
      return state
  }
}

export default DataTablesReducer
